// extracted by mini-css-extract-plugin
module.exports = {"userName":"UserList_userName__2zNBV","avatar":"UserList_avatar__3r2KI","li":"UserList_li__1jlOZ","options":"UserList_options__2TPU5"};